/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { getAttendanceCounts } from '@sportninja/common/features/game/attendance/utils/attendanceCounts'
import type { AttendanceCounts } from '@sportninja/common/features/game/attendance/utils/attendanceCounts'
import {
  attendanceCounterContainerStyle,
  titleAndTextContainerStyle,
  separatorStyle,
  counterTitleStyle,
  counterTextStyle,
} from '../../GameAttendanceCard/styles'
import type { AttendancePlayer } from '../types'

export interface AttendanceStatusCardProps {
  players: AttendancePlayer[]
}

// Larger than the shared sidebar counter styles, scoped to this modal so the
// sidebar widget is unaffected (title 12→14, value 24→31).
const titleOverride = css`
  font-size: 14px;
  line-height: 17px;
`
const valueOverride = css`
  font-size: 31px;
  line-height: 37px;
`

const COLUMNS: {
  key: keyof Pick<AttendanceCounts, 'yes' | 'maybe' | 'no' | 'unknown'>
  label: string
  color: string
}[] = [
  { key: 'yes', label: 'Yes', color: colors.SUCCESS_200 },
  { key: 'maybe', label: 'Maybe', color: colors.WARNING_200 },
  { key: 'no', label: 'No', color: colors.ERROR_200 },
  { key: 'unknown', label: 'Unknown', color: colors.NEUTRAL_100 },
]

/**
 * Attendance summary using the sidebar game-widget counter style, but showing
 * `count/total` per column (matching the mobile AttendanceStatusCard).
 */
const AttendanceStatusCard: React.FC<AttendanceStatusCardProps> = ({
  players,
}) => {
  const counts = getAttendanceCounts(players)
  return (
    <div css={attendanceCounterContainerStyle}>
      {COLUMNS.map((col, idx) => (
        <React.Fragment key={col.key}>
          {idx > 0 && <div css={separatorStyle} />}
          <div css={titleAndTextContainerStyle}>
            <p css={[counterTitleStyle(col.color), titleOverride]}>
              {col.label}
            </p>
            <p css={[counterTextStyle(col.color), valueOverride]}>
              {counts[col.key]}/{counts.total}
            </p>
          </div>
        </React.Fragment>
      ))}
    </div>
  )
}

export default AttendanceStatusCard
